export default "__VITE_ASSET__CH31YMEJ__"